import * as types from "./types";

const mutations = {
  [types.LOADING_ECOMMERCE](state, value) {
    state.loading = value;
  },
  [types.POST_ADMIN](state, ecom) {
    state.ecom = ecom;
  },
  [types.GET_USER](state, ecom) {
    state.ecom = ecom;
  },
  [types.GET_ORDER](state, ecom) {
    state.ecom = ecom;
  },
  [types.POST_COMPLETE_ORDER](state, ecom) {
    state.ecom = ecom;
  },
};

export default mutations;
